<template>
  <div>
    <McGrapqlTable
      :fields="fields"
      :apiClient="apiClient"
      :hasCheckbox="false"
      withCard
      searchable
      :activeFilters="activeFilters"
      :customHandlers="customHandlers"
      :filterBottom="true"
    >
      <template #title>
        <h4 class="my-4">{{ $t('driverScore.field.alertList') }}</h4>
      </template>

      <template #button-filter>
        <div class="d-flex justify-content-between mb-3">
          <b-row style="width: 100%">
            <b-col sm="6" md="8" xl="9">
              <McInlineFilter
                :filterItems="filterAlert"
                :activeKeys="activeFilters['alert_code']"
                isMultiple
                hasNavigation
                @update:activeKeys="
                  handleChangeActiveFilters([{ key: 'alert_code', values: $event }])
                "
              />
            </b-col>
            <b-col sm="6" md="4" xl="3">
              <date-picker
                v-model="period"
                :placeholder="defaultPeriodPlaceholder"
                :default-value="defaultPeriod"
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                range-separator=" - "
                range
                :disabled-date="disabledDates"
                @input="changeDate"
              ></date-picker>
            </b-col>
          </b-row>
        </div>
      </template>

      <template #cell(createdOn)="data">
        {{ momentDateShortMonth(data.value) }}<br />
        <span class="text-muted">{{ momentTimeSeconds(data.value) }}</span>
      </template>

      <template #cell(alertTrigger)="data">
        {{ checkDms(data.item.alertCode) || !data.value ? '-' : data.value }}
      </template>

      <template #cell(formattedAlertData)="data">
        {{
          checkDms(data.item.alertCode) || data.value == '-'
            ? '-'
            : parseFloat(data.value).toFixed(0)
        }}
      </template>

      <template #cell(address)="data">
        <b-skeleton
          width="70%"
          v-if="data.item.address == '' || data.item.address == null"
        ></b-skeleton>
        <span v-else>{{ data.item.address }}</span>
      </template>
    </McGrapqlTable>

    <b-modal
      v-if="detailNotification"
      id="modal-notification"
      scrollable
      hide-footer
      size="lg"
      centered
    >
      <template #modal-header="{ close }">
        <span>
          {{ `${detailNotification?.vehicle.licensePlate} - ${drivername}` }}
        </span>
        <i class="icon-outline_close" @click="close()"></i>
      </template>
      <div class="mc-modal-fleet mc-modal-fleet--notification">
        <div class="mc-modal-fleet__item">
          <div>
            <div
              class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif d-flex justify-content-between mb-3 mt-0"
            >
              <h4 :class="`text-${checkAlert(detailNotification?.alertCode)} float-start`">
                {{ convertAlert(detailNotification?.alertCode) }}
              </h4>
              <div class="d-flex">
                <McButton
                  variant="secondary"
                  :disabled="true"
                  icon="icon-outline_phone"
                  :text="$t('notification.action.callDriver')"
                />
                <McButton
                  v-if="checkDms(detailNotification.alertCode)"
                  class="ms-2"
                  icon="icon-fill_video"
                  :text="$t('global.action.watchVideo')"
                  @click="openVideo(detailNotification)"
                />
              </div>
            </div>
            <dl class="mc-modal-fleet__item-list clearfix pb-0">
              <dt>{{ $t('global.time.time') }}</dt>
              <dd>
                {{ momentDateShortMonth(detailNotification?.createdOn) }} -
                {{ momentTimeSeconds(detailNotification?.createdOn) }}
              </dd>
              <dt>{{ $t('global.object.location') }}</dt>
              <dd>
                {{ detailNotification?.address }}
              </dd>
              <dt v-if="detailNotification?.alertCode == 8">{{ $t('global.object.speed') }}</dt>
              <dd v-if="detailNotification?.alertCode == 8">
                {{
                  `${
                    detailNotification?.formattedAlertData !== '-'
                      ? parseFloat(detailNotification?.formattedAlertData).toFixed(0)
                      : '-'
                  } ${$t('global.unit.kmPerHour')}`
                }}
              </dd>
              <dt v-if="detailNotification?.alertCode == 8">{{ $t('global.object.limit') }}</dt>
              <dd v-if="detailNotification?.alertCode == 8">
                {{ `${detailNotification?.alertTrigger} ${$t('global.unit.kmPerHour')}` }}
              </dd>
            </dl>
          </div>
        </div>
        <h4
          class="mc-sidebar-liveview__list-notif-more d-block btn btn-outline-primary mt-3 mc-notif-open"
          @click="onClicked(detailNotification)"
        >
          <span class="mc-notif-open-text">
            <i class="mc-fa icon-outline_map"></i> {{ $t('global.action.seeDetail') }}
          </span>
        </h4>
      </div>
    </b-modal>
    <ModalVideo v-if="openVideoModal" :dataVideo="dataVideo" />
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import McGrapqlTable from '@/components/McGrapqlTable'
import McInlineFilter from '@/components/McInlineFilter'
import McButton from '@/components/McButton'
import ModalVideo from './ModalVideoPlayer.vue'
import { mapGetters } from 'vuex'
import { GET_RAW_ALERTS_WITH_ADDRESS } from '@/services/api/driverscore/score'
import i18n from '../../../../i18n'
import { GetAddressData } from '@/services/api/map'
import { getGeolocation } from '@/services/api/geolocation'
moment.locale('id')

export default {
  components: {
    McGrapqlTable,
    McInlineFilter,
    McButton,
    ModalVideo,
  },
  mixins: [Helper],
  props: {
    drivername: { type: String },
    lastSync: { type: String },
  },
  data() {
    return {
      filterDate: JSON.parse(localStorage.getItem('driverscore-filter-date')),
      period: [],
      activeFilters: {},
      detailNotification: {},
      lang: i18n.locale,
      dataVideo: {},
      openVideoModal: false,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    defaultPeriodPlaceholder() {
      let month = parseInt(this.filterDate.month)
      month = month > 9 ? month : `0${month}`
      const thisMonth = this.momentYYYYMMDDFromIndex(month, parseInt(this.filterDate.year))
      const today = this.momentYmDHms(this.lastSync)

      let placeHolder = `${this.momentDateShortMonth(
        moment(thisMonth).startOf('month')
      )} - ${this.momentDateShortMonth(today)}`

      if (
        this.momentM(today) > this.filterDate.month ||
        this.momentY(today) > this.filterDate.year
      ) {
        placeHolder = `${this.momentDateShortMonth(
          moment(thisMonth).startOf('month')
        )} - ${this.momentDateShortMonth(moment(thisMonth).endOf('month'))}`
      }
      return placeHolder
    },
    defaultPeriod() {
      let month = parseInt(this.filterDate.month)
      month = month > 9 ? month : `0${month}`
      const thisMonth = this.momentYYYYMMDDFromIndex(month, parseInt(this.filterDate.year))
      let start = this.momentYmD(moment(thisMonth).startOf('month'))
      const today = this.momentYmDHms(this.lastSync)

      let end = this.momentYmD(today)
      if (
        this.momentM(today) > this.filterDate.month ||
        this.momentY(today) > this.filterDate.year
      ) {
        end = this.momentYmD(moment(thisMonth).endOf('month'))
      }

      return [start, end]
    },
    isDms() {
      return this.hasAccessAll(['vehicle_video_trackers:read'])
    },
    fields() {
      return [
        {
          key: 'alert',
          label: this.$t('driverScore.field.alertType'),
          thClass: 'mc-table--250',
          isRedirectable: true,
          formatter: (value) => {
            return this.lang == 'en' ? value.descriptionEng : value.descriptionIdn
          },
        },
        {
          key: 'createdOn',
          label: this.$t('global.field.date'),
        },
        {
          key: 'vehicle.licensePlate',
          label: this.$t('global.object.licensePlate'),
        },
        {
          key: 'address',
          label: this.$t('global.object.location'),
          isResponsive: true,
        },
        {
          key: 'alertTrigger',
          label: this.$t('global.object.limit'),
        },
        {
          key: 'formattedAlertData',
          label: this.$t('global.field.actual'),
        },
      ]
    },
    alert_label() {
      let alerts = [
        {
          alert_code: 24,
          label: this.$t('global.alert.suddenAcceleration'),
          color: 'danger',
        },
        {
          alert_code: 23,
          label: this.$t('global.alert.suddenDeceleration'),
          color: 'danger',
        },
        {
          alert_code: 8,
          label: this.$t('global.alert.overspeed'),
          color: 'danger',
        },
        {
          alert_code: 25,
          label: this.$t('global.alert.sharpTurn'),
          color: 'danger',
        },
        {
          alert_code: 15,
          label: this.$t('global.alert.idleTime'),
          color: 'danger',
        },
        {
          alert_code: 16,
          label: this.$t('global.alert.parkTime'),
          color: 'danger',
        },
      ]
      const dms = [
        {
          alert_code: 54,
          label: this.$t('global.alert.smoking'),
          color: 'warning',
        },
        {
          alert_code: 53,
          label: this.$t('global.alert.yawning'),
          color: 'warning',
        },
        {
          alert_code: 51,
          label: this.$t('global.alert.asleep'),
          color: 'warning',
        },
        {
          alert_code: 55,
          label: this.$t('global.alert.calling'),
          color: 'warning',
        },
        {
          alert_code: 52,
          label: this.$t('global.alert.disturbance'),
          color: 'warning',
        },
        {
          alert_code: 56,
          label: this.$t('global.alert.outOfFrame'),
          color: 'warning',
        },
      ]

      if (this.hasAccessAll(['vehicle_video_trackers:read'])) {
        alerts.push(...dms)
      }
      return alerts
    },
    filterAlert() {
      let filters = [
        { id: 'all', label: this.$t('global.filter.all') },
        {
          id: 24,
          label: this.$t('global.alert.suddenAcceleration'),
        },
        {
          id: 23,
          label: this.$t('global.alert.suddenDeceleration'),
        },
        {
          id: 8,
          label: this.$t('global.alert.overspeed'),
        },
        {
          id: 25,
          label: this.$t('global.alert.sharpTurn'),
        },
        {
          id: 15,
          label: this.$t('global.alert.idleTime'),
        },
        {
          id: 16,
          label: this.$t('global.alert.parkTime'),
        },
      ]
      const dms = [
        {
          id: 54,
          label: this.$t('global.alert.smoking'),
        },
        {
          id: 53,
          label: this.$t('global.alert.yawning'),
        },
        {
          id: 51,
          label: this.$t('global.alert.asleep'),
        },
        {
          id: 55,
          label: this.$t('global.alert.calling'),
        },
        {
          id: 52,
          label: this.$t('global.alert.disturbance'),
        },
        {
          id: 56,
          label: this.$t('global.alert.outOfFrame'),
        },
      ]
      if (this.hasAccessAll(['vehicle_video_trackers:read'])) {
        filters.push(...dms)
      }
      return filters
    },
    apiClient() {
      return {
        get: async (filter) => {
          return this.getData(filter)
        },
      }
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
  },
  mounted() {
    this.handleChangeActiveFilters([{ key: 'startDate', values: this.defaultPeriod[0] }])
    this.handleChangeActiveFilters([{ key: 'endDate', values: this.defaultPeriod[1] }])
  },
  methods: {
    async getData(filter) {
      let filterDate = {}
      let filterAlerts = []
      if (Object.keys(this.activeFilters).length > 0) {
        Object.keys(this.activeFilters).forEach((key) => {
          let filterValue = this.activeFilters[key]

          if (key === 'startDate') {
            filterValue = new Date(filterValue)
            filterValue.setHours(0, 0, 0)
            filterValue = moment(filterValue).utc().format('YYYY-MM-DDTHH:mm:ss.000')
            filterDate[key] = filterValue + 'Z'
          } else if (key === 'endDate') {
            filterValue = new Date(filterValue)
            if (this.momentYmD(filterValue) < this.momentYmD(this.lastSync)) {
              filterValue.setHours(23, 59, 59)
              filterValue = moment(filterValue).utc().format('YYYY-MM-DDTHH:mm:ss.000') + 'Z'
            } else {
              filterValue = new Date(this.lastSync).toISOString()
            }
            filterDate[key] = filterValue
          } else {
            filterValue.map((item) => filterAlerts.push(Number(item)))
          }
        })
      }

      const alertCode =
        filterAlerts.length !== 0
          ? { alertCode: filterAlerts }
          : { alertCode: this.alert_label.map((item) => item.alert_code) }

      const res = await this.$apollo.query({
        query: GET_RAW_ALERTS_WITH_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            ...alertCode,
            driverId: [Number(this.$route.params.driverId)],
            startDate: filterDate.startDate,
            endDate: filterDate.endDate,
          },
        },
      })

      const useCache = this.isUsingCache()
      const coords = []
      const addresses = new Map()

      res.data.rawAlerts.rawAlerts.data.forEach((item) => {
        const lat = Number(item.latitude)
        const lon = Number(item.longitude)
        coords.push({ lat, lon })
      })

      if (coords.length > 0) {
        if (useCache) {
          const tempAddresses = await getGeolocation(coords)

          for (const [key, value] of tempAddresses) {
            addresses.set(key.replace(',', '&'), value.name)
          }
        } else {
          const result = await Promise.all(
            coords.map((coord) => GetAddressData(coord.lat, coord.lon))
          )

          for (const res of result) {
            const address = res.display_name
            const keyData = res.lat + '&' + res.lon
            addresses.set(keyData, address)
          }
        }
      }

      res.data.rawAlerts.rawAlerts.data.forEach(
        (item) => (item.address = addresses.get(item.latitude + '&' + item.longitude))
      )

      return res.data.rawAlerts.rawAlerts
    },

    disabledDates(date) {
      let month = parseInt(this.filterDate.month)
      month = month > 9 ? month : `0${month}`
      let start = new Date(this.momentYYYYMMDDFromIndex(month, parseInt(this.filterDate.year)))
      let end = this.momentAdd(this.momentAdd(start, 1, 'M'), -1, 'day')

      return date < start || date > end || date > new Date()
    },
    changeDate() {
      this.handleChangeActiveFilters([{ key: 'startDate', values: this.period[0] }])
      this.handleChangeActiveFilters([{ key: 'endDate', values: this.period[1] }])
    },
    convertAlert(alertCode) {
      const matchingObject = this.alert_label.find((item) => item.alert_code === alertCode)
      if (matchingObject) {
        return matchingObject.label
      } else {
        return ''
      }
    },
    checkAlert(alertCode) {
      const matchingObject = this.alert_label.find((item) => item.alert_code === alertCode)
      if (matchingObject) {
        return matchingObject.color
      } else {
        return ''
      }
    },
    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)

        if (filter.values === null || filter.values === undefined) return
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    handleClickRow(item) {
      this.detailNotification = item

      this.$bvModal.show('modal-notification')
    },
    onClicked(item) {
      const data = {
        ...item,
        driver_id: parseInt(this.$route.params.driverId),
        drivername: this.drivername,
      }

      localStorage.setItem('warning-detail-map', JSON.stringify(data))

      this.$router.push({
        name: 'Warning Details',
      })
    },
    openVideo(item) {
      this.dataVideo = item

      this.openVideoModal = true
      setTimeout(() => {
        this.$bvModal.show('modal-video')
      }, 700)
    },

    checkDms(alertCode) {
      const dmsCodes = [54, 53, 51, 55, 52, 56]
      const checkDms = dmsCodes.includes(alertCode)

      return checkDms
    },
  },
}
</script>
